import type { ReactNode } from 'react';

export type StressLevel = 'good' | 'comfortable' | 'slightly_tense' | 'tense' | 'unknown';

export type StressTheme = {
  level: StressLevel;
  heroGlow: string;
  heroShadow: string;
  iconBg: string;
  ringColor: string;
  accent: string;
  stressSubLabel: string;
};

const THEMES: Record<Exclude<StressLevel, 'unknown'>, Omit<StressTheme, 'level'>> = {
  good: {
    heroGlow: 'rgba(108, 248, 187, 0.2)',
    heroShadow: 'rgba(108, 248, 187, 0.3)',
    iconBg: '#eaf9f7',
    ringColor: '#eaf9f7',
    accent: '#006c49',
    stressSubLabel: '스트레스 안정됨',
  },
  comfortable: {
    heroGlow: 'rgba(173, 198, 255, 0.25)',
    heroShadow: 'rgba(37, 99, 235, 0.2)',
    iconBg: '#e6edf8',
    ringColor: '#e6edf8',
    accent: '#2563eb',
    stressSubLabel: '편안한 상태',
  },
  slightly_tense: {
    heroGlow: 'rgba(173, 198, 255, 0.25)',
    heroShadow: 'rgba(37, 99, 235, 0.2)',
    iconBg: '#e6edf8',
    ringColor: '#e6edf8',
    accent: '#2563eb',
    stressSubLabel: '약간 긴장됨',
  },
  tense: {
    heroGlow: 'rgba(243, 235, 228, 0.6)',
    heroShadow: 'rgba(146, 71, 0, 0.15)',
    iconBg: '#e6edf8',
    ringColor: '#f3ebe4',
    accent: '#924700',
    stressSubLabel: '긴장 상태',
  },
};

const DEFAULT_THEME = THEMES.comfortable;

/** stress 쿼리 라벨 → 4단계 타입 */
export function resolveStressLevel(label: string): StressLevel {
  const normalized = label.trim().replace(/\s+/g, '');
  if (!normalized || normalized === '--') return 'unknown';
  if (normalized.includes('약간') && normalized.includes('긴장')) return 'slightly_tense';
  if (normalized.includes('좋음')) return 'good';
  if (normalized.includes('편안')) return 'comfortable';
  if (normalized.includes('긴장')) return 'tense';
  return 'unknown';
}

export function getStressTheme(label: string): StressTheme {
  const level = resolveStressLevel(label);
  if (level === 'unknown') {
    return { level, ...DEFAULT_THEME };
  }
  return { level, ...THEMES[level] };
}

export function formatSessionRecordDate(ts: number | null): string {
  if (ts == null) return '';
  const d = new Date(ts);
  return `${d.getFullYear()}년 ${d.getMonth() + 1}월 ${d.getDate()}일의 기록`;
}
